<template>
  <div>
    <div id="app1">
      <div class="Overlay" style="margin: 10px 0">
        <el-button @click="getXy" type="primary">保存坐标</el-button>
        <el-button @click="deleteAll" type="danger">删除点</el-button>
        <el-form
          ref="form"
          :model="form"
          label-width="100px"
          style="padding-bottom: 0px; float: left; margin-right: 10px"
          @submit.native.prevent
        >
          <el-form-item label="详细地址：" prop="address">
            <el-autocomplete
              v-model="form.address"
              popper-class="autoAddressClass"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="false"
              placeholder="请输入详细地址并选择"
              class="input"
              @blur="handleBlur"
            >
              <template slot-scope="{ item }">
                <i class="el-icon-search fl mgr10" />
                <div style="overflow: hidden">
                  <div class="title">{{ item.title }}</div>
                  <span class="address ellipsis">{{ item.address }}</span>
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-form>
      </div>
      <div id="allmap" ref="allmap" />
    </div>
  </div>
</template>

<script>
// 天地图配置
const TIANDITU_CONFIG = {
  tk: 'e4d924258c1084ed7cde9c76fed4d520',
}

export default {
  props: ['Coordinate', 'type'],
  data() {
    return {
      map: null,
      mk: null,
      pointArr: [],
      datapointArr: [],
      datapolygonArr: [],
      polygonArr: [],
      form: {
        address: '',
        addrPoint: {
          lng: 0,
          lat: 0,
        },
      },
      addressName: '',
      address: '',
      initCoordinate: {
        lat: 34.659665,
        lng: 112.42033,
      },
      // 防止重复请求的标志
      isBlurHandling: false,
    }
  },
  mounted() {
    this.loadTiandituAPI()
  },
  methods: {
    loadTiandituAPI() {
      if (window.T && window.T.Map) {
        this.initmap()
        this.getCYS()
        this.replaces()
        return
      }

      const script = document.createElement('script')
      script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_CONFIG.tk}`
      script.onload = () => {
        console.log('天地图API加载成功')
        setTimeout(() => {
          this.initmap()
          this.getCYS()
          this.replaces()
        }, 500)
      }
      script.onerror = () => {
        console.error('天地图API加载失败')
        this.$message.error('地图API加载失败，请检查网络或密钥')
      }
      document.head.appendChild(script)
    },

    fn: function() {
      this.form.address = ''
      this.getCYS()
      console.log(this.type, 'type111111111')
    },

    replaces() {
      this.polygonArr = []
      this.datapointArr = []
      this.datapolygonArr = []
      this.Areas = this.polygonArr
      this.CenterPoint = this.datapointArr
    },

    getXy() {
      console.log(this.pointArr, 'this.pointArr')
      
      if (this.pointArr.length > 0) {
        this.datapointArr = []
        this.datapointArr.push(this.pointArr[0].point)
      } else {
        this.datapointArr = []
      }
      
      if (this.polygonArr.length > 0) {
        this.datapolygonArr = []
        this.datapolygonArr.push(this.polygonArr[0].zo)
      } else {
        this.datapolygonArr = []
      }
      
      const that = this
      if (that.datapointArr[0]) {
        // 直接使用已经获取到的地址，不再重新请求
        const addressToUse = that.form.address || that.addressName || '已选择位置'
        that.$emit('func', that.datapointArr, addressToUse, that.type)
      } else {
        that.$emit('func', [], '', that.type)
      }
    },

    /**
     * 地址搜索接口（用于搜索建议）
     */
    async querySearchAsync(str, cb) {
      if (!str || str.trim() === '') {
        cb([])
        return
      }

      try {
        const postStr = JSON.stringify({
          keyword: str,
          count: 20
        })
        
        const response = await fetch(`https://api.tianditu.gov.cn/geocoder?postStr=${encodeURIComponent(postStr)}&type=geocoder&tk=${TIANDITU_CONFIG.tk}`)
        const data = await response.json()
        
        const suggestions = []
        
        if (data.status === '0' && data.result && data.result.pois) {
          const pois = data.result.pois
          for (let i = 0; i < Math.min(pois.length, 20); i++) {
            const poi = pois[i]
            suggestions.push({
              title: poi.name,
              address: poi.address || '',
              point: { lng: poi.lon, lat: poi.lat },
              lng: poi.lon,
              lat: poi.lat
            })
          }
        }
        
        cb(suggestions)
      } catch (error) {
        console.error('地址搜索失败:', error)
        cb([])
      }
    },

    /**
     * 逆地理编码接口（用于根据坐标获取地址）
     */
    async reverseGeocode(lng, lat) {
      try {
        const postStr = JSON.stringify({
          lon: lng,
          lat: lat,
          ver: 1
        })
        
        const response = await fetch(`https://api.tianditu.gov.cn/geocoder?postStr=${encodeURIComponent(postStr)}&type=geocode&tk=${TIANDITU_CONFIG.tk}`)
        const data = await response.json()
        
        console.log('逆地理编码响应:', data)
        
        if (data.status === '0') {
          console.log('逆地理编码成功:', data.result)
          return data.result
        } else {
          console.error('逆地理编码失败:', data)
          this.$message.error('地址解析失败：' + (data.msg || '未知错误'))
          return { formatted_address: '', address: '' }
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('网络请求失败，请检查网络连接')
        return { formatted_address: '', address: '' }
      }
    },

    /**
     * 地理编码接口（根据地址获取经纬度）- 用于失去焦点时调用
     */
    async geocodeByAddress(address) {
      if (!address || address.trim() === '') {
        return null
      }

      try {
        // 按照您提供的接口格式：http://api.tianditu.gov.cn/geocoder?ds={"keyWord":"北京市海淀区莲花池西路28号"}&tk=您的密钥
        const ds = JSON.stringify({ keyWord: address })
        const url = `https://api.tianditu.gov.cn/geocoder?ds=${encodeURIComponent(ds)}&tk=${TIANDITU_CONFIG.tk}`
        
        console.log('地理编码请求URL:', url)
        const response = await fetch(url)
        const data = await response.json()
        
        console.log('地理编码响应:', data)
        
        if (data.status === '0' && data.location) {
          const { lon, lat, level, score } = data.location
          console.log(`地理编码成功: 经度=${lon}, 纬度=${lat}, 精度级别=${level}, 匹配度=${score}`)
          
          return {
            lng: parseFloat(lon),
            lat: parseFloat(lat),
            level: level,
            score: score,
            fullAddress: address
          }
        } else {
          console.error('地理编码失败:', data)
          this.$message.warning(`未找到地址"${address}"的坐标信息`)
          return null
        }
      } catch (error) {
        console.error('地理编码请求失败:', error)
        this.$message.error('地址解析网络请求失败')
        return null
      }
    },

    /**
     * 搜索框失去焦点事件处理
     */
    async handleBlur() {
      // 防止重复调用
      if (this.isBlurHandling) {
        return
      }
      
      const searchAddress = this.form.address
      if (!searchAddress || searchAddress.trim() === '') {
        return
      }
      
      this.isBlurHandling = true
      
      try {
        // 调用地理编码接口获取经纬度
        const locationInfo = await this.geocodeByAddress(searchAddress)
        
        if (locationInfo && locationInfo.lng && locationInfo.lat) {
          // 获取到经纬度后，在地图上标点
          this.addMarkerAndPanTo(locationInfo.lng, locationInfo.lat, searchAddress)
          
          // 可选：获取更详细的地址信息
          const addressDetail = await this.reverseGeocode(locationInfo.lng, locationInfo.lat)
          if (addressDetail && addressDetail.formatted_address) {
            this.form.address = addressDetail.formatted_address
            this.addressName = addressDetail.formatted_address
          }
          
          this.$message.success(`已定位到：${searchAddress}`)
        } else {
          console.log('未获取到有效坐标')
        }
      } catch (error) {
        console.error('失去焦点处理异常:', error)
      } finally {
        this.isBlurHandling = false
      }
    },

    /**
     * 添加标记并移动到指定位置
     */
    addMarkerAndPanTo(lng, lat, address) {
      if (!this.map) {
        console.error('地图未初始化')
        return
      }
      
      // 移除现有标记
      if (this.mk) {
        this.map.removeOverLay(this.mk)
      }
      
      const point = new T.LngLat(lng, lat)
      this.mk = new T.Marker(point)
      this.map.addOverLay(this.mk)
      
      // 移动地图中心到该点
      this.map.panTo(point)
      
      // 保存坐标信息
      this.pointArr = []
      this.pointArr[0] = { point: { lng: lng, lat: lat } }
      
      // 保存地址信息
      this.address = address
      this.form.addrPoint = { lng: lng, lat: lat }
    },

    initmap() {
      this.map = new T.Map('allmap')
      const point = new T.LngLat(this.initCoordinate.lng, this.initCoordinate.lat)
      this.map.centerAndZoom(point, 13)
      this.map.enableScrollWheelZoom(true)
      
      this.map.addEventListener('click', (e) => {
        this.handleMapClick(e)
      })
      
      console.log('天地图创建成功')
    },

    async handleMapClick(e) {
      const lnglat = e.lnglat
      const lng = lnglat.getLng()
      const lat = lnglat.getLat()
      
      if (this.mk) {
        this.map.removeOverLay(this.mk)
      }
      
      const point = new T.LngLat(lng, lat)
      this.mk = new T.Marker(point)
      this.map.addOverLay(this.mk)
      
      this.pointArr = []
      this.pointArr[0] = { point: { lng: lng, lat: lat } }
      
      this.map.panTo(point)
      
      // 获取地址信息
      const result = await this.reverseGeocode(lng, lat)
      if (result && result.formatted_address) {
        this.address = result.formatted_address
        this.form.address = this.address
        this.addressName = this.address
      }
    },

    deletePoint() {
      if (this.mk) {
        this.map.removeOverLay(this.mk)
        this.mk = null
      }
      this.pointArr = []
    },

    deleteAll() {
      if (this.map) {
        if (this.mk) {
          this.map.removeOverLay(this.mk)
          this.mk = null
        }
      }
      this.pointArr = []
      this.form.address = ''
      this.address = ''
      this.addressName = ''
    },

    async getCYS() {
      this.deleteAll()
      
      if (this.type == 'add') {
        this.Coordinate = ''
      }
      
      console.log(this.Coordinate, 'Coordinate')
      
      if (this.Coordinate && this.Coordinate != '' && this.Coordinate != '[]') {
        try {
          const CenterPoints = JSON.parse(this.Coordinate)
          for (let y = 0; y < CenterPoints.length; y++) {
            const point = new T.LngLat(CenterPoints[y].lng, CenterPoints[y].lat)
            const marker = new T.Marker(point)
            this.map.addOverLay(marker)
            
            if (y === CenterPoints.length - 1) {
              this.mk = marker
              this.pointArr[0] = { point: CenterPoints[y] }
              this.map.panTo(point)
              
              const result = await this.reverseGeocode(CenterPoints[y].lng, CenterPoints[y].lat)
              if (result && result.formatted_address) {
                this.address = result.formatted_address
                this.form.address = this.address
                this.addressName = this.address
              }
            }
          }
        } catch (error) {
          console.error('解析坐标失败:', error)
        }
      }
    },

    async getAddrByPoint(point) {
      const result = await this.reverseGeocode(point.lng, point.lat)
      this.map.panTo(new T.LngLat(point.lng, point.lat))
      if (result && result.formatted_address) {
        this.address = result.formatted_address
        this.form.address = this.address
        this.addressName = this.address
      }
    },

    async handleSelect(item) {
      console.log(item, 'item')
      
      this.form.address = (item.address || '') + (item.title || '')
      this.form.addrPoint = {
        lng: item.lng,
        lat: item.lat
      }
      
      if (this.mk) {
        this.map.removeOverLay(this.mk)
      }
      
      const point = new T.LngLat(item.lng, item.lat)
      this.mk = new T.Marker(point)
      this.map.addOverLay(this.mk)
      
      this.map.panTo(point)
      
      this.pointArr = []
      this.pointArr[0] = { point: { lng: item.lng, lat: item.lat } }
      
      const result = await this.reverseGeocode(item.lng, item.lat)
      if (result && result.formatted_address) {
        this.address = result.formatted_address
        this.form.address = this.address
        this.addressName = this.address
      }
    },
  },
}
</script>

<style scoped>
#allmap {
  width: 100%;
  height: 54vh;
}

/deep/.input input {
  width: 500px !important;
}

.autoAddressClass {
  li {
    i.el-icon-search {
      margin-top: 11px;
    }

    .mgr10 {
      margin-right: 10px;
      float: left;
    }

    .title {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .address {
      line-height: 1;
      font-size: 12px;
      color: #b4b4b4;
      margin-bottom: 5px;
    }
  }
}
</style>